var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["jsx"]: () => __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsx, ["jsxs"]: () => __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsxs });